import React from 'react';
import clsx from 'clsx';

import { MEDIA_STUDIO_LAYOUT } from './config';
import { MediaStudioProvider, useMediaStudio } from './context/MediaStudioContext';
import MediaStudioConfirmDialog from './components/media-studio-confirm-dialog/MediaStudioConfirmDialog';
import MediaStudioEmptyState from './components/media-studio-empty-state/MediaStudioEmptyState';
import MediaStudioWorkspace from './MediaStudioWorkspace';
import useBrandAssets from './hooks/useBrandAssets';

import 'react-contexify/dist/ReactContexify.css';
import './styles/tokens.scss';
import scss from './MediaStudio.module.scss';

function MediaStudioLayout() {
  const { config, features, editor, notice, layoutMode } = useMediaStudio();

  useBrandAssets({ features });

  return (
    <div
      ref={layoutMode.rootRef}
      className={clsx(
        scss.wrapper,
        config.layout === MEDIA_STUDIO_LAYOUT.EMBEDDED && scss.wrapperEmbedded,
        config.layout === MEDIA_STUDIO_LAYOUT.PAGE && scss.wrapperPage,
      )}>
      {notice.message ? (
        <p className={scss.notice} role='alert'>
          {notice.message}
        </p>
      ) : null}
      {editor.hasDocument ? <MediaStudioWorkspace /> : <MediaStudioEmptyState />}
      <MediaStudioConfirmDialog />
    </div>
  );
}

function MediaStudio({ config, saveActions, onClose }) {
  return (
    <MediaStudioProvider config={config} saveActions={saveActions} onClose={onClose}>
      <MediaStudioLayout />
    </MediaStudioProvider>
  );
}

export default MediaStudio;
